import React from 'react';
import { Github } from 'lucide-react';
import ThemeToggle from '../ThemeToggle';

const Toolbar = () => {
  return (
    <div className="fixed top-0 left-0 right-0 h-16 bg-white dark:bg-neutral-800 border-b border-gray-200 dark:border-neutral-700 z-50 transition-colors">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 h-full flex items-center justify-between">
        <div className="flex items-center gap-2 sm:gap-4">
          <h1 className="text-base sm:text-lg font-semibold text-gray-900 dark:text-gray-100">
            ZFS Pool Designer
          </h1>
        </div>

        <div className="flex items-center gap-2 sm:gap-3">
          <a
            href="https://github.com/philcifone/resilvr"
            target="_blank"
            rel="noopener noreferrer"
            className="p-2 rounded-lg hover:bg-gray-100 dark:hover:bg-neutral-700 transition-colors text-gray-700 dark:text-gray-300 hover:text-gray-900 dark:hover:text-gray-100"
            aria-label="View on GitHub"
            title="View on GitHub"
          >
            <Github className="w-5 h-5 sm:w-6 sm:h-6" />
          </a>
          <ThemeToggle />
        </div>
      </div>
    </div>
  );
};

export default Toolbar;
